import { MessageRoomConvertResponse } from "../../infra/api/service/message_room_api_convert";

export class MessageRoom {
  public static from(from: MessageRoomConvertResponse): MessageRoom {
    return new MessageRoom(
      from.id,
      from.projectID,
      from.customerID,
      from.companyID,
      from.customerUnRead,
      from.customerUnReadCount,
      from.companyUnRead,
      from.companyUnReadCount,
      from.isScout,
      from.hasContract,
      from.createdAt,
      from.updatedAt
    );
  }

  constructor(
    public readonly id: string,
    public readonly projectID: string,
    public readonly customerID: string,
    public readonly companyID: string,
    public readonly customerUnRead: boolean,
    public readonly customerUnReadCount: number | Long,
    public readonly companyUnRead: boolean,
    public readonly companyUnReadCount: number | Long,
    public readonly isScout: boolean,
    public readonly hasContract: boolean,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {}
}



// WEBPACK FOOTER //
// ./src/domain/model/message_room.ts